var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('StarRating',{attrs:{"star-size":45,"show-rating":false},on:{"rating-selected":_vm.onChange},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}}),(!_vm.isvalid)?_c('answer-required-field'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }